import React from "react"
import { useStyle } from "react-native-style-utilities"

import { useIsDarkMode } from "./AppThemeContextProvider"
import { AppText } from "./Text"
import { COLORS } from "./theme"

import type { Text } from "react-native"
import type { AppTextProps } from "./Text"
/**
 * A component that displays a link.
 */

export const LinkText = React.forwardRef<Text, AppTextProps>(function LinkText(
  { children, style, ...rest },
  ref,
) {
  const isDark = useIsDarkMode()

  return (
    <AppText
      ref={ref}
      role={"link"}
      style={useStyle(() => {
        return [
          {
            color: isDark ? COLORS.$link.dark : COLORS.$link.light,
          },
          style,
        ]
      }, [isDark, style])}
      {...rest}
    >
      {children}
    </AppText>
  )
})
